import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Axios from 'axios';
dayjs.locale('es');

const Calendar = ({ events, setEvents }) => {
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDay, setSelectedDay] = useState(null);
  const [showEventModal, setShowEventModal] = useState(false);
  const [newEventName, setNewEventName] = useState('');
  const [newEventHour, setNewEventHour] = useState('0');
  const [selectedEvent, setSelectedEvent] = useState(null); // Estado para almacenar el evento seleccionado
  const [showDetailModal, setShowDetailModal] = useState(false); // Estado para controlar el modal
  const [comandaDetalle, setComandaDetalle] = useState([]);
  useEffect(() => {

  }, []);

  // Función para mostrar el modal con los detalles del evento
  const showEventDetails = (event) => {
    Axios.get(process.env.REACT_APP_URLGETCOMANDACLIENTEDETALLE, {
        params: {
          comanda_id: event.id
        }, 
        headers: {
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods': 'GET, POST',
            'Access-Control-Allow-Headers': 'Content-Type'
        }
    }).then((response) => {
      setComandaDetalle(response.data.detalle_comanda)
    }).catch(error => {
        return error     
    })    
    
    setSelectedEvent(event);
    setShowDetailModal(true);
  };

  // Función para cerrar el modal
  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedEvent(null);
  };


  const changeMonth = (direction) => {
    setCurrentDate(currentDate.add(direction, 'month'));
  };

  const handleDayClick = (day) => {
    setSelectedDay(day ? currentDate.date(day) : null);
  };

  const closeDayView = () => {
    setSelectedDay(null);
  };

  const openEventModal = () => {
    setShowEventModal(true);
  };

  const closeEventModal = () => {
    setShowEventModal(false);
    setNewEventName('');
    setNewEventHour('0');
  };

  const addEvent = () => {
    if (!newEventName.trim()) {
      alert('El evento debe tener un nombre.');
      return;
    }

    const formattedDate = selectedDay.format('YYYY-MM-DD');
    const newEvent = { name: newEventName, hour: parseInt(newEventHour, 10) };

    setEvents({
      ...events,
      [formattedDate]: [...(events[formattedDate] || []), newEvent].sort((a, b) => a.hour - b.hour),
    });

    closeEventModal();
  };

  const calendarDays = Array.from({ length: currentDate.daysInMonth() }, (_, i) => i + 1);
  const monthName = currentDate.format('MMMM YYYY');

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* Controles de Mes */}
      <div className="flex justify-between items-center mb-6">
        <button onClick={() => changeMonth(-1)} className="p-2 bg-blue-500 text-white rounded-full">
          {'<'}
        </button>
        <h2 className="text-xl font-semibold capitalize">{monthName}</h2>
        <button onClick={() => changeMonth(1)} className="p-2 bg-blue-500 text-white rounded-full">
          {'>'}
        </button>
      </div>

      {/* Calendario */}
      <div className="grid grid-cols-7 gap-2 text-center">
        <div className="font-semibold">Dom</div>
        <div className="font-semibold">Lun</div>
        <div className="font-semibold">Mar</div>
        <div className="font-semibold">Mié</div>
        <div className="font-semibold">Jue</div>
        <div className="font-semibold">Vie</div>
        <div className="font-semibold">Sáb</div>

        {calendarDays.map((day, index) => {
          const formattedDate = currentDate.date(day).format('YYYY-MM-DD');
          const hasEvents = events[formattedDate]?.length > 0;

          return (
            <div
              key={index}
              className={`p-4 border rounded-lg cursor-pointer ${hasEvents ? 'bg-yellow-100' : 'bg-white hover:bg-gray-100'}`}
              onClick={() => handleDayClick(day)}
            >
              <div className="relative">
                <div className="font-semibold">{day}</div>
                {hasEvents && (
                  <div className="absolute bottom-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full">
                    {events[formattedDate].length}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Vista Detallada del Día */}
      {selectedDay && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-96 max-h-[90vh] overflow-auto">
            <h3 className="text-lg font-semibold mb-4">
              Ordenes para el {selectedDay.format('YYYY-MM-DD')}
            </h3>
            <button onClick={closeDayView} className="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full">
              ✕
            </button>

            {/*<button
              onClick={openEventModal}
              className="mb-4 px-4 py-2 bg-green-500 text-white rounded"
            >
              Agregar Evento
            </button>*/}

<div className="grid grid-cols-1 gap-1">
  {[...Array(11).keys()].map((hora) => (
    <div key={hora} className="p-2 border rounded-lg flex justify-between items-center">
      <div className="font-semibold">{hora+8}:00:00</div>
      <div className="text-sm text-gray-600">
        {events[selectedDay.format('YYYY-MM-DD')]?.filter((event) => {
          const eventHour = parseInt(event.hora.split(':')[0], 10); // Extrae solo la hora
          return eventHour === hora + 8; // Compara la hora extraída con la del bucle
        }).map((event, i) => (
          <div
            key={i}
            className="bg-blue-200 p-1 rounded text-xs cursor-pointer hover:bg-blue-300"
            onClick={() => showEventDetails(event)} // Envía el evento al modal
          >
            {event.usuario}
          </div>
        ))}
      </div>
    </div>
  ))}
</div>
          </div>
        </div>
      )}

      {/* Modal para Agregar Evento */}
      {showEventModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-96">
            <h3 className="text-lg font-semibold mb-4">Agregar Evento</h3>
            <input
              type="text"
              placeholder="Nombre del evento"
              value={newEventName}
              onChange={(e) => setNewEventName(e.target.value)}
              className="w-full p-2 border rounded mb-4"
            />
            <label className="block mb-2">Selecciona la hora:</label>
            <select
              value={newEventHour}
              onChange={(e) => setNewEventHour(e.target.value)}
              className="w-full p-2 border rounded mb-4"
            >
              {[...Array(24).keys()].map((hour) => (
                <option key={hour} value={hour}>{`${hour}:00`}</option>
              ))}
            </select>
            <div className="flex justify-between">
              <button onClick={closeEventModal} className="px-4 py-2 bg-gray-400 text-white rounded">
                Cancelar
              </button>
              <button onClick={addEvent} className="px-4 py-2 bg-blue-500 text-white rounded">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para mostrar el detalle del evento */}
      {showDetailModal && selectedEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-96">
            <h3 className="text-lg font-semibold mb-4">Detalles del Evento</h3>
            <p><strong>Usuario:</strong> {selectedEvent.usuario}</p>
            <p><strong>Hora:</strong> {selectedEvent.hora}</p>
            <p><strong>Estado:</strong> {selectedEvent.estado}</p>

            {/* 📌 Nueva grilla para mostrar comandaDetalle */}
            {comandaDetalle.length > 0 ? (
              <div className="mt-4">
                <h4 className="text-md font-semibold mb-2">Detalle de la Orden</h4>
                <div className="border border-gray-300 rounded-md overflow-hidden">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="bg-gray-200 text-gray-700">
                        <th className="p-2 border-b">Nombre</th>
                        <th className="p-2 border-b">Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {comandaDetalle.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                          <td className="p-2 border-b">{item.nombre}</td>
                          <td className="p-2 border-b text-center">{item.cantidad_producto}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <p className="text-gray-500 mt-2">No hay productos en la orden.</p>
            )}

           
            <div className="flex justify-end mt-4">
              <button
                onClick={closeDetailModal}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Calendar;
